<template>
  <div class="header dashboard">
    <div class="container">
      <div class="row">
        <div class="col-xl-12">
          <nav class="navbar navbar-expand-lg navbar-light px-0">
            <router-link class="navbar-brand" to="/"
              ><img :src="$t('head.logo')" alt="" /><span>{{
                $t("head.title")
              }}</span></router-link
            >
            <b-navbar-toggle target="navbarSupportedContent"> </b-navbar-toggle>

            <b-collapse as="div" id="navbarSupportedContent" is-nav>
              <ul class="navbar-nav">
                <li class="nav-item">
                  <router-link
                    class="nav-link"
                    to="/dashboard"
                    :class="active === 1 && 'active'"
                    >{{ $t("head.dashboard") }}</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link
                    class="nav-link"
                    to="/buy-sell"
                    :class="active === 2 && 'active'"
                    >{{ $t("head.buysell") }}</router-link
                  >
                </li>
                <li class="nav-item">
                  <router-link
                    class="nav-link"
                    to="/accounts"
                    :class="active === 3 && 'active'"
                    >{{ $t("head.assets") }}</router-link
                  >
                </li>
                <!-- <li class="nav-item">
                  <router-link
                    class="nav-link"
                    to="settings"
                    :class="active === 4 && 'active'"
                    >{{ $t("head.setting") }}</router-link
                  >
                </li> -->
              </ul>
            </b-collapse>
            <div class="dashboard_log my-2">
              <div class="d-flex align-items-center">
                <div class="account_money" v-if="false">
                  <ul>
                    <li class="crypto">
                      <span>{{ btcVal }}</span>
                      <i class="cc BTC-alt"></i>
                    </li>
                    <li class="usd">
                      <span>{{ usdVal }} USD</span>
                    </li>
                  </ul>
                </div>
                <b-nav-item-dropdown
                  right
                  menu-class="dropdown-menu"
                  toggle-class="p-0 i-false"
                  tag="div"
                  class="profile_log"
                >
                  <template #button-content>
                    <div class="user">
                      <span class="thumb"><i class="la la-user"></i></span>
                      <span class="name">{{ curLoginUser.realName }}</span>
                      <!-- <span class="arrow"
                        ><i class="la la-angle-down"></i
                      ></span> -->
                    </div>
                  </template>
                  <router-link to="/accounts" class="dropdown-item">
                    <i class="la la-user"></i> {{ $t("head.account") }}
                  </router-link>
                  <router-link to="/order/list" class="dropdown-item">
                    <i class="la la-file"></i> {{ $t("head.order") }}
                  </router-link>
                  <router-link to="/history" class="dropdown-item">
                    <i class="la la-book"></i> {{ $t("head.history") }}
                  </router-link>
                  <router-link to="/settings" class="dropdown-item">
                    <i class="la la-cog"></i> {{ $t("head.setting") }}
                  </router-link>
                  <router-link to="/changekyc" v-if="curLoginUser.certStatus < 1" class="dropdown-item">
                    <i class="la la-flag"></i> {{ $t("head.gokyc") }}
                  </router-link>
                  <!-- <router-link to="lock" class="dropdown-item">
                    <i class="la la-lock"></i> Lock
                  </router-link> -->
                  <router-link to="/signout" class="dropdown-item logout">
                    <i class="la la-sign-out"></i> {{ $t("head.signout") }}
                  </router-link>
                </b-nav-item-dropdown>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sumPrice, web_price } from "../../plugins/api/common";
import { amountinfo } from "../../plugins/api/amount";
// import store from "@/store/index";
export default {
  data() {
    return {
      show: false,
      amount: {},
      curLoginUser: {},
      // priceList: [],
      // usdVal: 0,
      // btcVal: 0,
    };
  },
  props: {
    active: Number,
  },
  computed: {
    usdVal: function () {
      return this.$store.state.usdVal;
    },
    btcVal: function () {
      return this.$store.state.btcVal;
    },
    avatar: function () {
      return this.$store.state.curLoginUser.avatar;
    },
  },
  mounted() {
    this.curLoginUser = this.$store.getters.curLoginUser;
  },
  created() {
    // console.log(this.$store())
    // this.curLoginUser = store().getters.curLoginUser;
    // this.priceList = store().getters.commomPrice;
    // web_price().then((pricedata) => {
    //   amountinfo().then((data) => {
    //     this.usdVal = sumPrice(data, pricedata.data, "USD", 2);
    //     this.btcVal = sumPrice(data, pricedata.data, "BTC", 4);
    //   });
    // });
    // amountlistinfo().then((res) => {
    //   this.amount = res;
    // });
  },
  // methods: {
  //   singout() {
  //     this.$router.push("/signin");
  //   },
  // },
};
</script>
